export default "__VITE_ASSET__92698af4__"